import {StandardDNACodon} from 'biojs/Codons';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';

import * as OrganismDAO from './OrganismDAO';

const OrganismActions = {
  getCodonUsage(organismId: number): void {
    OrganismDAO.getCodonUsage(organismId)
      .done(({data}: {data: Record<StandardDNACodon, number>}) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.ORGANISM_CODON_USAGE_FETCH,
          organismId,
          codonUsage: data,
        });
      })
      .fail(notifications.notifyError);
  },
};

export default OrganismActions;
